export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_complete_6.27c31def.jpg";